import PropTypes from 'prop-types';
import { NavItemPropType } from './Nav';
export var NavsObjectPropType = PropTypes.oneOfType([PropTypes.arrayOf(NavItemPropType), PropTypes.shape({
  left: PropTypes.arrayOf(NavItemPropType),
  right: PropTypes.arrayOf(NavItemPropType)
})]);